import {UserId} from '@webmate-web-core/shared/types/ids';
import {DateTime} from '@webmate-web-core/shared/types/base-types';
import _ from "lodash";
import {FilterOptionItem} from '@webmate-web-core/shared/types/filters';

export type Tag = any;

// Note: test_result will eventually be renamed to finding.
export type ResourceType = 'test_result' | 'test_execution' | 'screenshot' | 'video' | 'device_slot' | 'statedata_artifact';

export function tagEquals(a: Tag, b: Tag): boolean {
    return _.isEqual(a, b);
}

/**
 * Convert a tag string in the format "key=value" to a Tag object.
 */
export function tagFromString(tagString: string): Tag {
    const parts = tagString.split('=');
    const tag: Tag = {};
    if (parts.length === 1) {
        tag[parts[0]] = null;
    } else if (parts.length === 2) {
        tag[parts[0]] = parts[1];
    } else {
        throw new Error('Invalid tag format: ' + tagString);
    }
    return tag;
}

export function tagToString(tag: Tag): string {
    if (typeof tag !== 'object' || tag === null || Array.isArray(tag)) {
        return '';
    }
    const key = Object.keys(tag)[0];
    const value = tag[key];

    if (value === null || value === undefined) {
        return key; // If the value is null or undefined, just return the key.
    } else {
        return key + '=' + value;
    }
}

/**
 * Extracts tag buckets from the given aggregation. TODO: the distinction between 'tag' and 'label' is quite clumsy.
 */
export function extractTagBuckets(labelsAgg: any, tagOrLabel: 'tag' | 'label'): FilterOptionItem[] {
    let result: FilterOptionItem[] = [];
    const labelKeysAgg = labelsAgg.subAggregations.find((sa: any) => sa.name === tagOrLabel + 'Keys');
    if (!labelKeysAgg) return result;

    for (const labelKeyBucket of labelKeysAgg.buckets) {
        const key = labelKeyBucket.key;
        const labelValuesAgg = labelKeyBucket.subAggregations.find((sa: any) => sa.name === tagOrLabel + 'Values');
        const values = labelValuesAgg?.buckets ?? [];

        const items = values.length > 0
            ? values.map((val: any) => ({
                label: `${key}=${val.key} (${val.count})`,
                value: `${key}=${val.key}`
            }))
            : [{
                label: `${key} (${labelKeyBucket.count})`,
                value: `${key}`
            }];

        result = result.concat(items);
    }

    return result;
}

export interface CommentPayload {
    id: string,
    text: string
}

export interface WebmateComment {
    creator: UserId;
    creationTime: DateTime;
    payload: CommentPayload;
}
